import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { Container } from 'react-bootstrap';
import Masonry from 'react-masonry-css';
import styled from 'styled-components';

import RecordingCard from '../components/Recording/RecordingCard';
import EventCard from '../components/Event/EventCard';

const RelatedContentBlock = ({ references, lang, location }) => {
  console.log(location);
  const data = useStaticQuery(graphql`
    {
      sanityDictionaryGeneral {
        relatedContent {
          _type
          de
          en
        }
      }
      sanityDictionaryRecording {
        viewRecording {
          _type
          de
          en
        }
      }
      sanityDictionaryEvent {
        viewEvent {
          _type
          de
          en
        }
      }
    }
  `);
  const relatedContent = references.map((ref) => {
    if (ref && ref.__typename === 'SanityRecording') {
      return (
        <RecordingCard
          key={ref.id}
          recording={ref}
          lang={lang}
          relatedUrl={`${location}/recordings/`}
          btnText={
            data.sanityDictionaryRecording.viewRecording.de &&
            data.sanityDictionaryRecording.viewRecording.de
              ? data.sanityDictionaryRecording.viewRecording[lang]
              : 'view recording'
          }
        />
      );
    } else if (ref && ref.__typename === 'SanityEvent') {
      return (
        <EventCard
          key={ref.id}
          event={ref}
          lang={lang}
          relatedUrl={`${location}/events/`}
          btnText={
            data.sanityDictionaryEvent.viewEvent.de && data.sanityDictionaryEvent.viewEvent.de
              ? data.sanityDictionaryEvent.viewEvent[lang]
              : 'view event'
          }
        />
      );
    } else {
      return '';
    }
  });

  // Responsive breakpoints for Masonry component
  const breakpointColumnObj = {
    default: 3,
    768: 2,
    500: 1,
  };

  return (
    <Container style={{ maxWidth: '800px' }} as="section">
      <StyledSectionTitle>
        {data.sanityDictionaryGeneral.de && data.sanityDictionaryGeneral.de
          ? data.sanityDictionaryGeneral[lang]
          : 'Verwandte Inhalte'}
      </StyledSectionTitle>
      <Masonry
        breakpointCols={breakpointColumnObj}
        className="my-masonry-grid"
        columnClassName="my-masonry-grid_column"
      >
        {relatedContent}
      </Masonry>
    </Container>
  );
};

const StyledSectionTitle = styled.h3`
  font-weight: 400;
  text-transform: uppercase;
  font-size: 1.4rem;
  margin-bottom: 3rem;
`;

const StyledRelatedContainer = styled.div``;

export default RelatedContentBlock;
